"use strict";
exports.isLeapYear = isLeapYear;
var _index = require("./toDate.js");
function isLeapYear(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
